<template>
    <div id="responsly-widget" v-if="(!shouldHideIfAnswered || !isAnswered) && (!shouldHideIfDismissed || !isDismissed)">



        <!-- <div style="font-size:300px">
            Have you written a long-form guide or eBook (of substantially more than 4,000 words)?
        </div> -->



        <button class="button" :style="styles" @click="launch()" v-if="trigger=='button'">{{text}}</button>

        <div :class="getPosition('circle')" v-if="trigger=='circle'">
            <div class="circle" :style="styles"  @click="launch()" v-if="trigger=='circle'">
                    <helpIcon v-if="!active.popover && icon == 'help'"  :style="iconColor" class="logo"/>
                    <feedbackIcon v-if="!active.popover && icon == 'feedback'"  :style="iconColor" class="logo"/>
                    <contactIcon v-if="!active.popover && icon == 'contact'"  :style="iconColor" class="logo"/>



                <closeIcon  v-if="active.popover" class="svg-icon" :style="iconColor"/>
            </div>
            <div :class="getPosition('circle-text')" v-if="trigger=='circle' && circleLabel && !active.popover">{{text}}</div>
        </div>

        
        
        <!-- ribbon v2-->
        
        <div class="ribbon-window"  v-if="trigger=='ribbon'" :style="size" :class="{slide : active.ribbon && !mobile && iframeLoaded}" >
            <button :style="styles" class="ribbon-button" @click="launch()">
                <span class="ribbon-text">{{text}}</span>
                    <div class="ribbon-icon" v-if="icon != 'nothing'">
                        <!-- <openIcon v-if="!active.ribbon" class="svg-icon" :style="iconColor"/> -->
                        <helpIcon v-if="!active.ribbon && icon == 'help'"  :style="iconColor" class="logo"/>
                        <feedbackIcon v-if="!active.ribbon && icon == 'feedback'"  :style="iconColor" class="logo"/>
                        <contactIcon v-if="!active.ribbon && icon == 'contact'"  :style="iconColor" class="logo"/>


                        <closeIcon v-if="active.ribbon" class="svg-icon" :style="iconColor"/>
                    </div>
            </button>
            <div class="ribbon-wrapper">
            <iframe width="100%" height="100%" v-if="(active.ribbon && !mobile) || iframeLoaded" @load="load()" :src="formWithContextUrl" frameborder="0"></iframe>
            </div>
        </div>


        <!-- popup v2 -->

        <transition name="modal">
            <div class="modal-mask" :class="{light : theme == 'light'}" v-if="active.popup && !mobile && iframeLoaded"></div>
        </transition>

        <div class="popup-box" :style="size" v-if="active.popup && !mobile" :class="{'popup-open' : active.popup && !mobile && iframeLoaded}" >
            <button  @click="launch()" class="popup-button">
                <closeIcon :class="{white : theme == 'dark'}"/>
            </button>
            <iframe @load="load()" v-if="(active.popup && !mobile) || iframeLoaded" width="100%" height="100%"  :src="formWithContextUrl" frameborder="0"></iframe>
            <div class="powered-by" v-if="form !== 'https://thehills.responsly.com/f/lgmbXxy4?widget=1'">Powered by <a href="https://www.responsly.com" target="blank">Responsly</a></div>
        </div>

    

        <!-- popup mobilki v2 -->

        <div class="popup-box-mobile"  v-if="mobile && mobileActive" :class="{'popup-open' : mobileActive && mobile && iframeLoaded}" >
            <button  @click="launch()" class="popup-button-mobile">
                <closeIcon />
            </button>
            <iframe @load="load()" v-if="(mobileActive && mobile) || iframeLoaded" width="100%" height="100%"  :src="formWithContextUrl" frameborder="0"></iframe>
        </div>

        <!-- slider v2 -->

        <transition name="modal">
        <div class="modal-mask" v-if="active.slider && !mobile && iframeLoaded"></div>
        </transition>

        <div :class="{'slider-open' : active.slider && !mobile && iframeLoaded,
        'slider-box-right' : position == 'right', 'slider-box-left' : position == 'left'}" v-if="window == 'slider' && !mobile"
        :style="size">

            <button class="slider-button" @click="launch()">
                    <closeIcon class="white"/>
            </button>

            <iframe @load="load()" v-if="(active.slider && !mobile) || iframeLoaded"  width="100%" height="100%" :src="formWithContextUrl" frameborder="0"></iframe>
        </div>


        <!-- slidup v2 -->


        <div
        :class="{'slidup-window' : size == 'large' ,'slidup-window-small': size == 'small' ,
        'slidup-window-small-right' : position == 'right' && size == 'small',
        'slidup-open' : active.slidup && !mobile && iframeLoaded && size  == 'large',
        'slidup-open-small' : active.slidup && !mobile && iframeLoaded && size  == 'small'}"
         v-if="window =='slidup' && !mobile">
            
            
            <button class="slidup-button" @click="launch()">
                    <closeIcon/>
            </button>

            <iframe @load="load()" v-if="(active.slidup && !mobile) || iframeLoaded"  width="100%" height="100%" :src="formWithContextUrl" frameborder="0"></iframe>

        </div>

        <!-- popover v2 -->

        <div  :class="{'popover-open' : active.popover && !mobile && iframeLoaded,
        'popover-right' : circle == 'right',
        'popover-left' : circle == 'left' }"
        v-if="window =='popover' && !mobile"
        :style="size">
            <iframe @load="load()" v-if="(active.popover && !mobile) || iframeLoaded" width="100%" height="100%" :src="formWithContextUrl" frameborder="0"></iframe>
        </div>

    </div>  
</template>

<script>

import close from '../assets/svg/close.svg'
import help from '../../../frontend/src/assets/svg/widget/help.svg'
import contact from '../../../frontend/src/assets/svg/widget/contact.svg'
import feedback from '../../../frontend/src/assets/svg/widget/feedback.svg'

import manageCookies from '../mixins/manageCookies'

export default {
    name: 'Widget',
    mixins: [
        manageCookies
    ],
    components: {
        closeIcon : close,
        helpIcon : help,
        contactIcon : contact,
        feedbackIcon : feedback,
    },
    props: {
        trigger:{
            type: String,
            default: 'nothing' // change to nothing
        },
        window:{
            type: String,
            default: 'popup'
        },
        form:{
            type: String,
            default: 'http://form.responsly.test/f/Abg3YNR0'
        },
        id:{
            type: String,
            default: 'Zwl5Jmm8'
        },
        theme:{
            type: String,
            default: 'dark' 
        },
        size:{
            type: String,
            default: ''
        },
        text:{
            type: String,
            default: '' 
        },
        styles:{
            type: String,
            default: '' 
        },
        circle:{
            type: String,
            default: 'left' 
        },
        position:{
            type: String,
            default: 'left' 
        },
        scrolling:{
            type: String,
            default: 'false' 
        },
        pageLoad:{
            type: String,
            default: 'false' 
        },
        delay:{
            type: String,
            default: '' 
        },
        exitInit:{
            type: String,
            default: 'false' 
        },
        exitInitWithMobile:{
            type: String,
            default: 'false'
        },
        icon:{
            type: String,
            default: 'help'
        },
        iconColor:{
            type: String,
            default: 'fill:white;'
        },
        tokenKey:{
            type: String,
            default: ''
        },
        closeAfter:{
            type: String,
            default: ''
        },
        specificUrl:{
            type: Array,
            default: () => []
        },
        period:{
            type: String,
            default: ''
        },
        hideIfAnswered:{
            type: String,
            default: 'false'
        },
        answeredDays:{
            type: String,
            default: '14'
        },
        hideIfDismissed:{
            type: String,
            default: 'false'
        },
        dismissedDays:{
            type: String,
            default: '14'
        }
    },
    data: function() {
        return {
            circleLabel: this.text.length>0,
            active: {
                popup: false,
                slider: false,
                slidup: false,
                popover: false,
                ribbon: false,
            },
            mobile: false,
            mobileActive: false,
            iframeLoaded: false,
            scrolled: false,
            isDelayed: this.delay.length>0,
            isClosedAfter: this.closeAfter.length>0,
            isSpecificUrl: this.specificUrl.length>0,
            isPeriodOfTime: this.period.length>0,
            shouldHideIfAnswered: this.hideIfAnswered === 'true',
            isAnswered: false,
            shouldHideIfDismissed: this.hideIfDismissed === 'true',
            isDismissed: false,
        }
    },
    computed: {
        formWithContextUrl() {
            try {
                const url = new URL(this.form, window.location.href);

                if (!url.searchParams.has('widget_source_url')) {
                    url.searchParams.set('widget_source_url', window.location.href);
                }

                return url.toString();
            } catch (e) {
                return this.form;
            }
        },
    },
    methods: {
        getFormIdHash(){
            try {
                const url = new URL(this.form, window.location.href);
                const match = url.pathname.match(/\/f\/(?:new\/)?([^\/\?#]+)/);
                return match && match[1] ? match[1] : null;
            } catch (e) {
                return null;
            }
        },
        getStateId(){
            return this.getFormIdHash() || this.id;
        },
        isWidgetOpen(){
            return this.mobileActive
                || this.active.popup
                || this.active.slider
                || this.active.slidup
                || this.active.popover
                || this.active.ribbon;
        },
        launch(){

            const wasOpen = this.isWidgetOpen();

            this.mobileActive = !this.mobileActive

            switch(this.window){
                case 'popup':
                    if(this.iframeLoaded==true){
                        setTimeout(function() { this.iframeLoaded = false }.bind(this), 200);
                    }
                    this.active.popup = !this.active.popup;
                    break;
                case 'slider':
                    if(this.iframeLoaded==true){
                        setTimeout(function() { this.iframeLoaded = false }.bind(this), 250);
                    }
                    this.active.slider = !this.active.slider;
                    break; 
                case 'slidup':
                    if(this.iframeLoaded==true){
                        setTimeout(function() { this.iframeLoaded = false }.bind(this), 350);
                    }
                    this.active.slidup = !this.active.slidup;
                    break; 
                case 'popover':
                    if(this.iframeLoaded==true){
                        setTimeout(function() { this.iframeLoaded = false }.bind(this), 200);
                    }
                    this.active.popover = !this.active.popover;
                    break; 
                case 'ribbon':
                    if(this.iframeLoaded==true){
                        setTimeout(function() { this.iframeLoaded = false }.bind(this), 250);
                    }
                    this.active.ribbon = !this.active.ribbon;
                    break; 
                default:
                    break;
            }

            const isNowOpen = this.isWidgetOpen();

            if (this.shouldHideIfDismissed && wasOpen && !isNowOpen) {
                this.markAsDismissed();
            }
        },
        getPosition(x){
            switch(x){
                case 'circle':
                    return this.circle==='left' ?  'popover-box-left' : 'popover-box-right'  
                case 'circle-text':
                    return this.circle==='left' ?  'circle-text-left' : 'circle-text-right'
            }
        },
        ifMobile(){
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) || (window.innerWidth < 361)) {
                this.mobile = true;
            }
            
        },
        load(){
            this.iframeLoaded = true;
        },
        isOwnIframe(source){
            if (!source || !this.$el || typeof this.$el.querySelectorAll !== 'function') {
                return false;
            }

            return Array.from(this.$el.querySelectorAll('iframe'))
                .some((frame) => frame.contentWindow === source);
        },
        getCloseDelayInMs(){
            const closeAfterSeconds = parseInt(this.closeAfter, 10);

            if (!Number.isNaN(closeAfterSeconds) && closeAfterSeconds >= 0) {
                return closeAfterSeconds * 1000;
            }

            return 5000;
        },
        handleScroll (event) {
            if(!this.scrolled)
                this.launch();
            this.scrolled=true;
        },
        handleExitMouseOut (event) {
            if (this.mobile) {
                return;
            }

            if ((this.shouldHideIfAnswered && this.isAnswered) ||
                (this.shouldHideIfDismissed && this.isDismissed)) {
                return;
            }

            const related = event.relatedTarget || event.toElement;

            if (!related && event.clientY <= 0) {
                this.exit();
            }
        },
        exit(){
            if (!this.isWidgetOpen()) {
                this.launch();
            }
        },
        handlePeriod(){
           let cookie = 'period-' + this.id
           if( this.getCookie(cookie) == false ){ // ogarnac nazewnictwo
               this.launch();
               this.setCookie(cookie,1,this.period);
           }
        },
        handleSpecificUrl(){
            this.specificUrl.forEach(element => {
                if(window.location.href.indexOf(element) > -1) {
                    this.launch();
                }
            });
        },
        checkIfAnswered(){
            let cookie = 'answered-' + this.getStateId();
            return this.getCookie(cookie) !== false;
        },
        markAsAnswered(){
            let cookie = 'answered-' + this.getStateId();
            const days = parseInt(this.answeredDays, 10);
            this.setCookie(cookie, '1', isNaN(days) ? 14 : days);
            this.isAnswered = true;
        },
        checkIfDismissed(){
            let cookie = 'dismissed-' + this.getStateId();
            return this.getCookie(cookie) !== false;
        },
        markAsDismissed(){
            let cookie = 'dismissed-' + this.getStateId();
            const days = parseInt(this.dismissedDays, 10);
            const ttlDays = isNaN(days) ? 14 : days;
            this.setCookie(cookie, '1', ttlDays);
            this.requestDismissCookie(ttlDays);
            this.isDismissed = true;
        },
        requestDismissCookie(days){
            try {
                const origin = new URL(this.form, window.location.href).origin;
                const url = origin + '/form/dismiss/' + encodeURIComponent(this.getStateId()) + '?days=' + encodeURIComponent(String(days));

                if (navigator && typeof navigator.sendBeacon === 'function') {
                    const data = new FormData();
                    data.append('days', String(days));
                    navigator.sendBeacon(url, data);
                    return;
                }

                fetch(url, {
                    method: 'POST',
                    mode: 'no-cors',
                    credentials: 'include',
                    keepalive: true,
                }).catch(() => {});
            } catch (e) {
                // ignore
            }
        },
    },
    created: function() {
        this.ifMobile();

        // Check if widget should be hidden because it was already answered
        if(this.shouldHideIfAnswered) {
            this.isAnswered = this.checkIfAnswered();
        }

        // Check if widget should be hidden because it was dismissed
        if(this.shouldHideIfDismissed) {
            this.isDismissed = this.checkIfDismissed();
        }

        // Listen for form submission events
        window.addEventListener("message", (event) => {
            if (!this.isOwnIframe(event.source)) {
                return;
            }
            if(event.data === 'close-form') {
                setTimeout(() => {
                    if (this.shouldHideIfAnswered) {
                        this.markAsAnswered();
                    }

                    if (this.isWidgetOpen()) {
                        this.launch();
                    }
                }, this.getCloseDelayInMs());
            }
        }, false);

        if(this.scrolling == 'true')
            window.addEventListener('scroll', this.handleScroll)

        if(this.pageLoad == 'true')
            this.launch();

        if(this.isDelayed)
            setTimeout(function() {
                if (!this.isWidgetOpen()) {
                    this.launch()
                }
            }.bind(this), parseInt(this.delay)*1000)

        if(this.isPeriodOfTime)
            this.handlePeriod()

        if(this.isSpecificUrl)
            this.handleSpecificUrl();

        if (this.exitInit === 'true') {
            if (this.mobile && this.exitInitWithMobile === 'true') {
                // On mobile we optionally auto-open after 30s if not answered/dismissed
                setTimeout(() => {
                    if ((this.shouldHideIfAnswered && this.isAnswered) ||
                        (this.shouldHideIfDismissed && this.isDismissed)) {
                        return;
                    }

                    const isOpen = this.mobileActive
                        || this.active.popup
                        || this.active.slider
                        || this.active.slidup
                        || this.active.popover
                        || this.active.ribbon;

                    if (!isOpen) {
                        this.launch();
                    }
                }, 30000);
            } else if (!this.mobile) {
                document.addEventListener('mouseout', this.handleExitMouseOut);
            }
        }



    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
        if (this.exitInit === 'true') {
            document.removeEventListener('mouseout', this.handleExitMouseOut);
        }
    },

}
</script>

<style lang="scss">

    .svg-icon {
        height: 28px;
        width: 28px;
    }

    .logo {
        width: 30px;
        height: 30px;
    }

    .popup-box-mobile {
        position: fixed;
        will-change: opacity;
        opacity: 0;
        transition: opacity 200ms ease-in-out;
        top:0;
        left:0;
        width: 100%;
        height: 100%;
        z-index: 9999999;
    }

    .popup-button-mobile {
        position: absolute;
        right: 10px;
        background: white;
        border: 0;
        border-radius: 50%;
        width: 35px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        top: 10px;
    }

    .popup-box {
        position: fixed;
        will-change: opacity;
        opacity: 0;
        transition: opacity 200ms ease-in-out;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: 400px;
        height: 350px;
        z-index: 999;
    }

    .popup-open {
        opacity: 1;
    }

    .popup-button {
        align-self: flex-end;
        background: transparent;
        border: 0;
        cursor: pointer;
        margin-right: -10px;
        margin-bottom: -5px;
    }



    .slider-box-left, .slider-box-right {
        
        will-change: transform;
        transition: transform 350ms ease-in-out;
        position: fixed;
        top:0;
        height: 100%;
        width: 40%;
        display: flex;
        z-index: 999;
    }

    .slider-box-right {
        transform: translate(100%, 0);
        right: 0;
        flex-direction: row;
    }

    .slider-box-left {
        transform: translate(-100%, 0);
        left:0;
        flex-direction: row-reverse;
    }

    .slider-open {
        transform: translate(0, 0);
    }

    .slider-button {
        align-self: flex-start;
        background: transparent;
        border: 0;
        cursor: pointer;
    }

    .slidup-window {
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, 100%);
        will-change: transform;
        transition: transform 350ms ease-in-out;
        display: flex;
        flex-direction: column;

        width: 80vw;
        max-width: 650px;
        height: 300px;
    }


    .slidup-window-small {
        position: fixed;
        bottom: 0;
        left: 30px;
        transform: translate(0, 100%);
        will-change: transform;
        transition: transform 350ms ease-in-out;
        display: flex;
        flex-direction: column;

        width: 80vw;
        max-width: 300px;
        height: 350px;
    }

    .slidup-window-small-right {
        left:unset;
        right: 30px;
    }

    .slidup-open-small {
        transform: translate(0, 0);
    }

    .slidup-open {
        transform: translate(-50%, 0);
    }

    .slidup-button {
        position: absolute;
        right: 10px;
        top:10px;
        border: 0;
        cursor: pointer;
        background: transparent;
    }

    .ribbon-window {
        position: fixed;
        top: 50%;
        right: 0;
        width: 300px;
        height: 450px;
        transform: translate(100%, -50%);
        will-change: transform;
        transition: transform 250ms ease-in-out;
        box-shadow: 0 2px 4px rgb(0 0 0 / 8%), 0 2px 12px rgb(0 0 0 / 6%);
        z-index: 999;
    }

    .ribbon-button {
        position: absolute;
        top: 50%;
        left: -48px;
        transform: rotate(-90deg) translateX(-52%);  //check -50 later
        transform-origin: left top;
        height: 48px;
        display: flex;
        align-items: center;
        padding: 0 12px;
        color: white;
        box-shadow: 0 2px 4px rgb(0 0 0 / 8%), 0 2px 12px rgb(0 0 0 / 6%);
        background-color: blue;
        cursor: pointer;
        border: 0;
        text-decoration: none;
        outline: none;
    }

    .ribbon-text {
        flex: 1;
        font-size: 18px;
        font-family: Helvetica, Arial, sans-serif;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .ribbon-wrapper {
        position: relative;
        height: 100%;
        width: 100%;
    }

    .ribbon-icon {
        margin-right: 12px;
        position: relative;
        order: -1;
        width: 28px;
        height: 28px;
        transform: rotate(90deg);

    }

    .slide {
        transform: translate(0, -50%);
    }

    .white {
        fill:white;
    }


    .button {
        border: 0;
        background: blue;
        color:white;
        font-family: 'Helvetica', 'Arial', sans-serif;
        padding: 7px 20px 7px 20px;
        font-weight: bold;

        &:hover {
            cursor: pointer;
        }
    }

    .close-button {
        color: white;
        font-weight: bold;
        background-color: transparent;
        border: 0;
        &:hover {
            cursor: pointer;
        }
    }

    .circle {
        height: 60px;
        width: 60px;
        background-color: rgb(48, 71, 236);
        box-shadow: rgb(0 0 0 / 6%) 0px 1px 6px 0px, rgb(0 0 0 / 16%) 0px 2px 32px 0px;
        border-radius: 50%;
        bottom: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        &:hover {
            cursor: pointer;
        }

    }

    .popover-box-left, .popover-box-right  {
        position: fixed;
        bottom: 20px;
        display: flex;
        gap: 20px;
        align-items: flex-end;
    }

    .popover-box-left {
        left: 20px;
        flex-direction: row;
    }

    .popover-box-right {
        right: 20px;
        flex-direction: row-reverse;
    }

    .circle-text-right, .circle-text-left {
        background: rgb(255, 255, 255);
        border-radius: 11px;
        padding: 12px 20px;
        font-size: 14px;
        line-height: 21px;
        font-family: Helvetica, Arial, sans-serif;
        max-width: 210px;
        overflow-wrap: break-word;
        box-shadow: 0 3px 10px rgb(0 0 0 / 35%);
    }

    .circle-text-left::before, .circle-text-right::before  {
        content: '';
        position: absolute;
        visibility: visible;
        bottom: 0;
        
        border: 15px solid transparent;
        border-bottom: 15px solid rgb(255, 255, 255);
        -webkit-filter: drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.35));
        filter        : drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.35));
        z-index: -1;
    }

    .circle-text-right::before {
        right: 65px;
        box-shadow: -6px 7px 16px rgb(0 0 0 / 5%);
    }

    .circle-text-left::before {
        left: 65px;
        box-shadow: 4px 9px 16px rgb(0 0 0 / 5%);
    }

    .circle-text-left::after, .circle-text-right::after {
        content: '';
        position: absolute;
        visibility: visible;
        bottom: 0;
        border: 15px solid transparent;
        border-bottom: 15px solid rgb(255, 255, 255);
        clear: both;
    }

    .circle-text-right::after {
        right: 65px;
    }

    .circle-text-left::after {
        left: 65px;
    }

    .popover-left, .popover-right {
        will-change: transform;
        transition: opacity .3s ease;
        opacity: 0;
        position: fixed;
        overflow: hidden;
        border-radius: 10px;
        height: 380px;
        width: 350px;
        bottom: 95px;
        box-shadow: rgb(0 0 0 / 16%) 0px 5px 40px;
        background: transparent;
    }

    .popover-left {
        left: 20px;
    }

    .popover-right {
        right: 20px;
    }

    .popover-open {
        opacity: 1;
    }

    .modal-mask {
        position: fixed;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
        height: 100%;
        width: 100%;
        transition: opacity 0.3s ease;
    }

    .light {
        background-color: rgba(239, 239, 240, 0.5);
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .powered-by {
        font-family: -apple-system,BlinkMacSystemFont,'Segoe UI','Roboto','Oxygen','Ubuntu','Cantarell','Fira Sans','Droid Sans','Helvetica Neue',sans-serif;
        font-size: 14px;
        margin-top: 4px;
        color: white;
        a {
            text-decoration: underline;
            color: white;
        }
    }

    .modal-mask.light + .popup-box {
        .powered-by {
            color: black;
            a {
                color: black;
            }
        }
    }

</style>>


